import { useTranslation } from "react-i18next";
import { UserCircle2 } from "lucide-react";
import { DetailCard, DetailRow } from "./DetailCard";
import { fmtDateTime } from "./detailFmt";

// معلومات معد الأمر — من أنشأه ومتى.
export const DetailCreator = ({ doc }) => {
  const { t } = useTranslation();
  return (
    <DetailCard tid="section-creator" icon={UserCircle2}
                title={t("purchases.podetail.creatorInfo")}>
      <DetailRow tid="row-creator"
                 label={t("purchases.podetail.creator")}
                 value={doc.created_by_name || doc.created_by || "—"} />
      {doc.created_at ? (
        <DetailRow tid="row-created-at"
                   label={t("purchases.podetail.createdAt")}
                   value={<span className="num font-mono">{fmtDateTime(doc.created_at)}</span>} />
      ) : null}
    </DetailCard>
  );
};
